import { API_PREFIX } from './constant'
import { Request } from './request'

export interface AmountParams {
  limitType?: number
}

export function AmountList(params: AmountParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/user/user/getUserLimits`,
    method: 'GET',
    params,
  }
}

export function saveUserLimitInfo(params: any): Request {
  return {
    url: `${API_PREFIX}/blade-user/user/user/saveUserLimitInfo`,
    method: 'POST',
    body: params,
  }
}
